import React, { useState, useEffect, Fragment } from 'react';

// Mirrors EUUDIListsConstants.CountriesGlobal (C#) - the world country list used only for this
// field's address Country. Keys are the ISO alpha-2 suffix of the CMS lookup key; Country.Value
// stores the full key ("general.country-iso-be") and the EUDAMED XML export converts it to "BE".
const COUNTRY_KEY_PREFIX = "general.country-iso-";

// Older rows stored the bare ISO code ("BE") - both forms become "general.country-iso-be".
// EUDAMED uses EL for Greece and XI for Northern Ireland, so older GR / GB-NIR are mapped to them.
const LEGACY_COUNTRY_KEYS = { "gr": "el", "gb-nir": "xi" };
const toCountryKey = (value) => {
    const v = String(value ?? "").trim();
    if (!v) return "";
    let code;
    if (v.toLowerCase().startsWith(COUNTRY_KEY_PREFIX)) code = v.toLowerCase().slice(COUNTRY_KEY_PREFIX.length);
    else if (/^[A-Za-z]{2}$/.test(v)) code = v.toLowerCase();
    else return v;
    return COUNTRY_KEY_PREFIX + (LEGACY_COUNTRY_KEYS[code] ?? code);
};

const ADDRESS_COUNTRIES = [
    { key: "AF", value: "Afghanistan" }, { key: "AL", value: "Albania" },
    { key: "DZ", value: "Algeria" }, { key: "AD", value: "Andorra" },
    { key: "AO", value: "Angola" }, { key: "AG", value: "Antigua and Barbuda" },
    { key: "AR", value: "Argentina" }, { key: "AM", value: "Armenia" },
    { key: "AU", value: "Australia" }, { key: "AT", value: "Austria" },
    { key: "AZ", value: "Azerbaijan" }, { key: "BS", value: "Bahamas" },
    { key: "BH", value: "Bahrain" }, { key: "BD", value: "Bangladesh" },
    { key: "BB", value: "Barbados" }, { key: "BY", value: "Belarus" },
    { key: "BE", value: "Belgium" }, { key: "BZ", value: "Belize" },
    { key: "BJ", value: "Benin" }, { key: "BT", value: "Bhutan" },
    { key: "BO", value: "Bolivia" }, { key: "BA", value: "Bosnia and Herzegovina" },
    { key: "BW", value: "Botswana" }, { key: "BR", value: "Brazil" },
    { key: "BN", value: "Brunei" }, { key: "BG", value: "Bulgaria" },
    { key: "BF", value: "Burkina Faso" }, { key: "BI", value: "Burundi" },
    { key: "CV", value: "Cabo Verde" }, { key: "KH", value: "Cambodia" },
    { key: "CM", value: "Cameroon" }, { key: "CA", value: "Canada" },
    { key: "CF", value: "Central African Republic" }, { key: "TD", value: "Chad" },
    { key: "CL", value: "Chile" }, { key: "CN", value: "China" },
    { key: "CO", value: "Colombia" }, { key: "KM", value: "Comoros" },
    { key: "CG", value: "Congo (Congo-Brazzaville)" }, { key: "CR", value: "Costa Rica" },
    { key: "CI", value: "Cote d'Ivoire" }, { key: "HR", value: "Croatia" },
    { key: "CU", value: "Cuba" }, { key: "CY", value: "Cyprus" },
    { key: "CZ", value: "Czechia" }, { key: "CD", value: "Democratic Republic of the Congo" },
    { key: "DK", value: "Denmark" }, { key: "DJ", value: "Djibouti" },
    { key: "DM", value: "Dominica" }, { key: "DO", value: "Dominican Republic" },
    { key: "EC", value: "Ecuador" }, { key: "EG", value: "Egypt" },
    { key: "SV", value: "El Salvador" }, { key: "GQ", value: "Equatorial Guinea" },
    { key: "ER", value: "Eritrea" }, { key: "EE", value: "Estonia" },
    { key: "SZ", value: "Eswatini" }, { key: "ET", value: "Ethiopia" },
    { key: "FJ", value: "Fiji" }, { key: "FI", value: "Finland" },
    { key: "FR", value: "France" }, { key: "GA", value: "Gabon" },
    { key: "GM", value: "Gambia" }, { key: "GE", value: "Georgia" },
    { key: "DE", value: "Germany" }, { key: "GH", value: "Ghana" },
    { key: "EL", value: "Greece" }, { key: "GD", value: "Grenada" },
    { key: "GT", value: "Guatemala" }, { key: "GN", value: "Guinea" },
    { key: "GW", value: "Guinea-Bissau" }, { key: "GY", value: "Guyana" },
    { key: "HT", value: "Haiti" }, { key: "HN", value: "Honduras" },
    { key: "HU", value: "Hungary" }, { key: "IS", value: "Iceland" },
    { key: "IN", value: "India" }, { key: "ID", value: "Indonesia" },
    { key: "IR", value: "Iran" }, { key: "IQ", value: "Iraq" },
    { key: "IE", value: "Ireland" }, { key: "IL", value: "Israel" },
    { key: "IT", value: "Italy" }, { key: "JM", value: "Jamaica" },
    { key: "JP", value: "Japan" }, { key: "JO", value: "Jordan" },
    { key: "KZ", value: "Kazakhstan" }, { key: "KE", value: "Kenya" },
    { key: "KI", value: "Kiribati" }, { key: "KW", value: "Kuwait" },
    { key: "KG", value: "Kyrgyzstan" }, { key: "LA", value: "Laos" },
    { key: "LV", value: "Latvia" }, { key: "LB", value: "Lebanon" },
    { key: "LS", value: "Lesotho" }, { key: "LR", value: "Liberia" },
    { key: "LY", value: "Libya" }, { key: "LI", value: "Liechtenstein" },
    { key: "LT", value: "Lithuania" }, { key: "LU", value: "Luxembourg" },
    { key: "MG", value: "Madagascar" }, { key: "MW", value: "Malawi" },
    { key: "MY", value: "Malaysia" }, { key: "MV", value: "Maldives" },
    { key: "ML", value: "Mali" }, { key: "MT", value: "Malta" },
    { key: "MH", value: "Marshall Islands" }, { key: "MR", value: "Mauritania" },
    { key: "MU", value: "Mauritius" }, { key: "MX", value: "Mexico" },
    { key: "FM", value: "Micronesia" }, { key: "MD", value: "Moldova" },
    { key: "MC", value: "Monaco" }, { key: "MN", value: "Mongolia" },
    { key: "ME", value: "Montenegro" }, { key: "MA", value: "Morocco" },
    { key: "MZ", value: "Mozambique" }, { key: "MM", value: "Myanmar" },
    { key: "NA", value: "Namibia" }, { key: "NR", value: "Nauru" },
    { key: "NP", value: "Nepal" }, { key: "NL", value: "Netherlands" },
    { key: "NZ", value: "New Zealand" }, { key: "NI", value: "Nicaragua" },
    { key: "NE", value: "Niger" }, { key: "NG", value: "Nigeria" },
    { key: "KP", value: "North Korea" }, { key: "MK", value: "North Macedonia" },
    { key: "NIR", value: "Northern Ireland" }, { key: "NO", value: "Norway" },
    { key: "OM", value: "Oman" }, { key: "PK", value: "Pakistan" },
    { key: "PW", value: "Palau" }, { key: "PS", value: "Palestine" },
    { key: "PA", value: "Panama" }, { key: "PG", value: "Papua New Guinea" },
    { key: "PY", value: "Paraguay" }, { key: "PE", value: "Peru" },
    { key: "PH", value: "Philippines" }, { key: "PL", value: "Poland" },
    { key: "PT", value: "Portugal" }, { key: "QA", value: "Qatar" },
    { key: "RO", value: "Romania" }, { key: "RU", value: "Russia" },
    { key: "RW", value: "Rwanda" }, { key: "KN", value: "Saint Kitts and Nevis" },
    { key: "LC", value: "Saint Lucia" }, { key: "VC", value: "Saint Vincent and the Grenadines" },
    { key: "WS", value: "Samoa" }, { key: "SM", value: "San Marino" },
    { key: "ST", value: "Sao Tome and Principe" }, { key: "SA", value: "Saudi Arabia" },
    { key: "SN", value: "Senegal" }, { key: "RS", value: "Serbia" },
    { key: "SC", value: "Seychelles" }, { key: "SL", value: "Sierra Leone" },
    { key: "SG", value: "Singapore" }, { key: "SK", value: "Slovakia" },
    { key: "SI", value: "Slovenia" }, { key: "SB", value: "Solomon Islands" },
    { key: "SO", value: "Somalia" }, { key: "ZA", value: "South Africa" },
    { key: "KR", value: "South Korea" }, { key: "SS", value: "South Sudan" },
    { key: "ES", value: "Spain" }, { key: "LK", value: "Sri Lanka" },
    { key: "SD", value: "Sudan" }, { key: "SR", value: "Suriname" },
    { key: "SE", value: "Sweden" }, { key: "CH", value: "Switzerland" },
    { key: "SY", value: "Syria" }, { key: "TW", value: "Taiwan" },
    { key: "TJ", value: "Tajikistan" }, { key: "TZ", value: "Tanzania" },
    { key: "TH", value: "Thailand" }, { key: "TL", value: "Timor-Leste" },
    { key: "TG", value: "Togo" }, { key: "TO", value: "Tonga" },
    { key: "TT", value: "Trinidad and Tobago" }, { key: "TN", value: "Tunisia" },
    { key: "TR", value: "Turkey" }, { key: "TM", value: "Turkmenistan" },
    { key: "TV", value: "Tuvalu" }, { key: "UG", value: "Uganda" },
    { key: "UA", value: "Ukraine" }, { key: "AE", value: "United Arab Emirates" },
    { key: "GB", value: "United Kingdom" }, { key: "XI", value: "United Kingdom (Northern Ireland)" },
    { key: "US", value: "United States" }, { key: "UY", value: "Uruguay" },
    { key: "UZ", value: "Uzbekistan" }, { key: "VU", value: "Vanuatu" },
    { key: "VA", value: "Vatican City" }, { key: "VE", value: "Venezuela" },
    { key: "VN", value: "Vietnam" }, { key: "YE", value: "Yemen" },
    { key: "ZM", value: "Zambia" }, { key: "ZW", value: "Zimbabwe" },
];

const countryName = (countryKey) =>
    ADDRESS_COUNTRIES.find(c => toCountryKey(c.key) === countryKey)?.value ?? "";

const emptyAddress = () => ({
    AddressComplement: "",
    City: "",
    Country: { Value: "", Text: "" },
    GPSCoordinates: { Latitude: { Value: "" }, Longitude: { Value: "" } },
    POBox: "",
    PostCode: "",
    Street: "",
    StreetNum: "",
});

// Public is tri-state while editing: "" means "not yet answered" (distinct from an explicit
// "No"), so a plain checkbox can't represent it - the edit form uses a Yes/No/unset select.
const emptyContact = () => ({
    EMail: "",
    Phone: "",
    Public: "",
    Website: "",
});

/** Normalize legacy string ContactDetails into ElectronicContacts shape. */
const normalizeContact = (raw) => {
    if (raw == null || raw === "")
        return emptyContact();
    if (typeof raw === "string")
        return { ...emptyContact(), EMail: raw };

    const pub = raw.Public ?? raw.public;
    return {
        EMail: raw.EMail ?? raw.eMail ?? raw.Email ?? raw.email ?? "",
        Phone: raw.Phone ?? raw.phone ?? "",
        Public: pub === true || pub === "true" ? true : (pub === false || pub === "false" ? false : ""),
        Website: raw.Website ?? raw.website ?? "",
    };
};

const normalizeContacts = (raw) => {
    if (raw == null || raw === "")
        return { ContactDetail: [] };

    if (typeof raw === "string") {
        const legacy = String(raw).trim();
        return legacy
            ? { ContactDetail: [{ ...emptyContact(), EMail: legacy }] }
            : { ContactDetail: [] };
    }

    if (typeof raw !== "object")
        return { ContactDetail: [] };

    const detail = raw.ContactDetail ?? raw.contactDetail;
    if (Array.isArray(detail))
        return { ContactDetail: detail.map(normalizeContact) };

    if (raw.EMail != null || raw.eMail != null || raw.Phone != null || raw.phone != null || raw.Website != null || raw.website != null)
        return { ContactDetail: [normalizeContact(raw)] };

    return { ContactDetail: [] };
};

const contactRowHasContent = (c) =>
    !!(String(c?.EMail || "").trim() || String(c?.Phone || "").trim() || String(c?.Website || "").trim());

const isValidEmailFormat = (value) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || "").trim());

const toStoredContacts = (contacts) => {
    const list = normalizeContacts(contacts).ContactDetail
        .map((c) => {
            const email = String(c.EMail || "").trim();
            const phone = String(c.Phone || "").trim();
            const website = String(c.Website || "").trim();
            if (!email && !phone && !website)
                return null;
            return {
                EMail: email || null,
                Phone: phone || null,
                Public: c.Public === true,
                Website: website || null,
            };
        })
        .filter(Boolean);

    return list.length === 0 ? null : { ContactDetail: list };
};

/** Normalize legacy string GeographicalAddress into structured shape (AddressComplement). */
const normalizeAddress = (raw) => {
    if (raw == null || raw === "")
        return emptyAddress();

    if (typeof raw === "string") {
        return { ...emptyAddress(), AddressComplement: raw };
    }

    if (typeof raw !== "object")
        return emptyAddress();

    const lat = raw.GPSCoordinates?.Latitude?.Value ?? raw.GPSCoordinates?.Latitude ?? "";
    const lng = raw.GPSCoordinates?.Longitude?.Value ?? raw.GPSCoordinates?.Longitude ?? "";
    const countryKey = toCountryKey(raw.Country?.Value ?? raw.Country?.value ?? (typeof raw.Country === "string" ? raw.Country : ""));

    return {
        AddressComplement: raw.AddressComplement ?? raw.addressComplement ?? "",
        City: raw.City ?? raw.city ?? "",
        Country: {
            Value: countryKey,
            Text: countryName(countryKey) || raw.Country?.Text || raw.Country?.text || "",
        },
        GPSCoordinates: {
            Latitude: { Value: lat === null || lat === undefined ? "" : String(lat) },
            Longitude: { Value: lng === null || lng === undefined ? "" : String(lng) },
        },
        POBox: raw.POBox ?? raw.poBox ?? "",
        PostCode: raw.PostCode ?? raw.postCode ?? "",
        Street: raw.Street ?? raw.street ?? "",
        StreetNum: raw.StreetNum ?? raw.streetNum ?? "",
    };
};

const normalizeDesigner = (parsed) => {
    if (!parsed || typeof parsed !== "object")
        return {
            GeographicalAddress: emptyAddress(),
            ContactDetails: { ContactDetail: [emptyContact()] },
        };

    const contacts = normalizeContacts(parsed.ContactDetails);
    return {
        ...parsed,
        GeographicalAddress: normalizeAddress(parsed.GeographicalAddress),
        ContactDetails: {
            ContactDetail: contacts.ContactDetail.length > 0
                ? contacts.ContactDetail
                : [emptyContact()],
        },
    };
};

const toStoredAddress = (address) => {
    const a = normalizeAddress(address);
    const latRaw = a.GPSCoordinates?.Latitude?.Value;
    const lngRaw = a.GPSCoordinates?.Longitude?.Value;
    const lat = latRaw === "" || latRaw == null ? null : Number(latRaw);
    const lng = lngRaw === "" || lngRaw == null ? null : Number(lngRaw);
    const hasGps = lat != null && !Number.isNaN(lat) && lng != null && !Number.isNaN(lng);

    return {
        AddressComplement: a.AddressComplement || null,
        City: a.City || null,
        Country: a.Country?.Value
            ? { Value: a.Country.Value, Text: a.Country.Text || a.Country.Value }
            : null,
        GPSCoordinates: hasGps
            ? { Latitude: { Value: lat }, Longitude: { Value: lng } }
            : null,
        POBox: a.POBox || null,
        PostCode: a.PostCode || null,
        Street: a.Street || null,
        StreetNum: a.StreetNum || null,
    };
};

const toStoredDesigner = (designer) => ({
    ...designer,
    GeographicalAddress: toStoredAddress(designer.GeographicalAddress),
    ContactDetails: toStoredContacts(designer.ContactDetails),
});

const ProductDesignerLink = ({
    UDI,
    setUDI,
    initialData = '{}',
    hiddenFieldName = "Form.EUProductUDI.NaturalOrLegalPersonWhoManufacturedAndDesingedTheDevice",
    fieldTitle = "Natural or Legal Person Who Manufactured and Designed the Device",
    forceIsEditing = null,
    validationTrigger = 0
}) => {
    const languages = [
        { key: "ANY", value: "ANY" },
        { key: "en", value: "English" }, { key: "is", value: "Icelandic" },
        { key: "no", value: "Norwegian" }, { key: "tr", value: "Turkish" },
        { key: "bg", value: "Bulgarian" }, { key: "cs", value: "Czech" },
        { key: "da", value: "Danish" }, { key: "de", value: "German" },
        { key: "et", value: "Estonian" }, { key: "el", value: "Greek" },
        { key: "es", value: "Spanish" }, { key: "fr", value: "French" },
        { key: "hr", value: "Croatian" }, { key: "it", value: "Italian" },
        { key: "lv", value: "Latvian" }, { key: "lt", value: "Lithuanian" },
        { key: "hu", value: "Hungarian" }, { key: "mt", value: "Maltese" },
        { key: "nl", value: "Dutch" }, { key: "pl", value: "Polish" },
        { key: "pt", value: "Portuguese" }, { key: "ro", value: "Romanian" },
        { key: "sk", value: "Slovak" }, { key: "sl", value: "Slovenian" },
        { key: "fi", value: "Finnish" }, { key: "sv", value: "Swedish" },
        { key: "ga", value: "Irish" }
    ];

    const parseInitial = () => {
        try {
            const parsed = typeof initialData === 'string' ? JSON.parse(initialData) : initialData;
            return parsed && Object.keys(parsed).length > 0
                ? normalizeDesigner(parsed)
                : normalizeDesigner({});
        } catch {
            return normalizeDesigner({});
        }
    };

    const [isEditing, setIsEditing] = useState(forceIsEditing != null ? forceIsEditing : false);
    const [formData, setFormData] = useState(parseInitial);
    const [fieldErrors, setFieldErrors] = useState({});
    const [showValidation, setShowValidation] = useState(false);

    const isDesignerEmpty = (designer) => {
        if (!designer)
            return true;
        if (designer.SRN && String(designer.SRN).trim())
            return false;
        if (designer.OrganizationName && String(designer.OrganizationName).trim())
            return false;
        if (designer.Language?.Value)
            return false;

        const address = normalizeAddress(designer.GeographicalAddress);
        const hasAddressContent = !!(
            address.AddressComplement || address.City || address.Country?.Value ||
            address.POBox || address.PostCode || address.Street || address.StreetNum ||
            address.GPSCoordinates?.Latitude?.Value || address.GPSCoordinates?.Longitude?.Value
        );
        if (hasAddressContent)
            return false;

        const contacts = normalizeContacts(designer.ContactDetails).ContactDetail;
        if (contacts.some(contactRowHasContent))
            return false;

        return true;
    };

    const getAddressValidationErrors = (designer) => {
        const errors = {};
        if (!designer)
            return errors;

        const address = normalizeAddress(designer.GeographicalAddress);
        const hasSrn = !!(designer.SRN && String(designer.SRN).trim());

        if (!hasSrn) {
            if (!address.Country?.Value)
                errors.Country = "Country is mandatory when SRN is not provided";
            if (!address.PostCode || !String(address.PostCode).trim())
                errors.PostCode = "Post Code is mandatory when SRN is not provided";
            if (!address.City || !String(address.City).trim())
                errors.City = "City is mandatory when SRN is not provided";
            if (!designer.OrganizationName || !String(designer.OrganizationName).trim())
                errors.OrganizationName = "Organization Name is mandatory when SRN is not provided";
        }

        const lat = address.GPSCoordinates?.Latitude?.Value;
        const lng = address.GPSCoordinates?.Longitude?.Value;
        const hasLat = lat !== "" && lat != null;
        const hasLng = lng !== "" && lng != null;
        if (hasLat !== hasLng)
            errors.GPS = "Both GPS Latitude and Longitude are required when GPS coordinates are provided";

        return errors;
    };

    const getContactValidationErrors = (designer) => {
        const errors = {};
        if (!designer)
            return errors;

        const hasSrn = !!(designer.SRN && String(designer.SRN).trim());
        const contacts = normalizeContacts(designer.ContactDetails).ContactDetail;
        const usable = contacts.filter(contactRowHasContent);
        const isPublicUnset = (c) => c.Public !== true && c.Public !== false;

        if (!hasSrn) {
            if (usable.length === 0)
                errors.ContactDetails = "At least one Contact Detail is required when SRN is not provided";
            contacts.forEach((c, i) => {
                if (!contactRowHasContent(c))
                    return;
                const email = String(c.EMail || "").trim();
                if (!email)
                    errors[`Contact_${i}_EMail`] = "Email is mandatory when SRN is not provided";
                else if (!isValidEmailFormat(email))
                    errors[`Contact_${i}_EMail`] = "Email must be a valid email address";
                if (isPublicUnset(c))
                    errors[`Contact_${i}_Public`] = "Public is mandatory when SRN is not provided";
            });
        } else {
            contacts.forEach((c, i) => {
                if (!contactRowHasContent(c))
                    return;
                const email = String(c.EMail || "").trim();
                if (!email)
                    errors[`Contact_${i}_EMail`] = "Email is required when other contact fields are provided";
                else if (!isValidEmailFormat(email))
                    errors[`Contact_${i}_EMail`] = "Email must be a valid email address";
                if (isPublicUnset(c))
                    errors[`Contact_${i}_Public`] = "Public is required when other contact fields are provided";
            });
        }

        return errors;
    };

    const getValidationErrors = (designer) => {
        // The whole section is optional - if it was left untouched, there is nothing to validate.
        if (isDesignerEmpty(designer))
            return {};

        return {
            ...getAddressValidationErrors(designer),
            ...getContactValidationErrors(designer),
        };
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setShowValidation(true);
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleLanguageChange = (e) => {
        const value = e.target.value;
        const text = e.target.options[e.target.selectedIndex].text;
        setShowValidation(true);
        setFormData(prev => ({
            ...prev,
            Language: { Value: value, Text: text }
        }));
    };

    const handleAddressChange = (e) => {
        const { name, value } = e.target;
        setShowValidation(true);
        setFormData(prev => ({
            ...prev,
            GeographicalAddress: {
                ...normalizeAddress(prev.GeographicalAddress),
                [name]: value,
            },
        }));
    };

    const handleAddressCountryChange = (e) => {
        const value = e.target.value;
        const text = e.target.options[e.target.selectedIndex].text;
        setShowValidation(true);
        setFormData(prev => ({
            ...prev,
            GeographicalAddress: {
                ...normalizeAddress(prev.GeographicalAddress),
                Country: { Value: value, Text: value ? text : "" },
            },
        }));
    };

    const handleGpsChange = (axis, value) => {
        setShowValidation(true);
        setFormData(prev => {
            const address = normalizeAddress(prev.GeographicalAddress);
            return {
                ...prev,
                GeographicalAddress: {
                    ...address,
                    GPSCoordinates: {
                        ...address.GPSCoordinates,
                        [axis]: { Value: value },
                    },
                },
            };
        });
    };

    const handleContactChange = (index, field, value) => {
        setShowValidation(true);
        setFormData(prev => {
            const contacts = normalizeContacts(prev.ContactDetails);
            const next = [...contacts.ContactDetail];
            next[index] = { ...normalizeContact(next[index]), [field]: value };
            return { ...prev, ContactDetails: { ContactDetail: next } };
        });
    };

    const addContactRow = () => {
        setShowValidation(true);
        setFormData(prev => {
            const contacts = normalizeContacts(prev.ContactDetails);
            return {
                ...prev,
                ContactDetails: { ContactDetail: [...contacts.ContactDetail, emptyContact()] },
            };
        });
    };

    const removeContactRow = (index) => {
        setShowValidation(true);
        setFormData(prev => {
            const contacts = normalizeContacts(prev.ContactDetails);
            const next = contacts.ContactDetail.filter((_, i) => i !== index);
            return {
                ...prev,
                ContactDetails: {
                    ContactDetail: next.length > 0 ? next : [emptyContact()],
                },
            };
        });
    };

    // Keep EUUDI in sync while editing so parent Save validates the current values.
    useEffect(() => {
        if (!isEditing)
            return;

        setUDI(prevItem => ({
            ...prevItem,
            NaturalOrLegalPersonWhoManufacturedAndDesingedTheDevice: toStoredDesigner(formData),
        }));
    }, [formData, isEditing]);

    // Live field validation while editing / after the user has interacted.
    useEffect(() => {
        if (!isEditing)
            return;
        setFieldErrors(showValidation ? getValidationErrors(formData) : {});
    }, [formData, isEditing, showValidation]);

    useEffect(() => {
        if (forceIsEditing != null)
            setIsEditing(forceIsEditing);
    }, [forceIsEditing]);

    // Parent's Save failed validation for this field - surface the same inline field errors a user
    // would see from editing directly, instead of only the generic banner far away.
    useEffect(() => {
        if (validationTrigger)
            setShowValidation(true);
    }, [validationTrigger]);

    // Entering edit: refresh form from current UDI value (or initial), start validation fresh.
    useEffect(() => {
        if (!isEditing)
            return;

        const fromUdi = UDI?.NaturalOrLegalPersonWhoManufacturedAndDesingedTheDevice;
        const source = fromUdi && typeof fromUdi === "object" && Object.keys(fromUdi).length > 0
            ? fromUdi
            : parseInitial();
        setFormData(normalizeDesigner(source));
        setShowValidation(false);
        setFieldErrors({});
    }, [isEditing]);

    const safeVal = (val) => val || "";

    const addressForm = normalizeAddress(formData.GeographicalAddress);
    const contactForm = normalizeContacts(formData.ContactDetails);
    const viewData = normalizeDesigner(
        UDI?.NaturalOrLegalPersonWhoManufacturedAndDesingedTheDevice
        && typeof UDI.NaturalOrLegalPersonWhoManufacturedAndDesingedTheDevice === "object"
            ? UDI.NaturalOrLegalPersonWhoManufacturedAndDesingedTheDevice
            : formData
    );

    const renderFieldError = (message) => (
        message ? <div><span className="form-field-error-message">{message}</span></div> : null
    );

    const renderContactTableRows = (dataObject) => {
        const contacts = normalizeContacts(dataObject.ContactDetails).ContactDetail
            .filter(contactRowHasContent);
        if (contacts.length === 0)
            return <tr><td style={{ paddingLeft: "24px" }}>Contact Details</td><td></td></tr>;

        return contacts.map((c, i) => (
            <Fragment key={`contact-view-${i}`}>
                <tr><td colSpan={2}><strong>{contacts.length > 1 ? `Contact Detail ${i + 1}` : "Contact Details"}</strong></td></tr>
                <tr><td style={{ paddingLeft: "24px" }}>Email</td><td>{safeVal(c.EMail)}</td></tr>
                <tr><td style={{ paddingLeft: "24px" }}>Phone</td><td>{safeVal(c.Phone)}</td></tr>
                <tr><td style={{ paddingLeft: "24px" }}>Public</td><td>{c.Public === true ? "Yes" : c.Public === false ? "No" : ""}</td></tr>
                <tr><td style={{ paddingLeft: "24px" }}>Website</td><td>{safeVal(c.Website)}</td></tr>
            </Fragment>
        ));
    };

    const renderTableRows = (dataObject) => {
        const address = normalizeAddress(dataObject.GeographicalAddress);
        return (
            <>
                <tr><td>SRN</td><td>{safeVal(dataObject.SRN)}</td></tr>
                <tr><td>Language</td><td>{safeVal(dataObject.Language?.Text)}</td></tr>
                <tr><td>Organization Name</td><td>{safeVal(dataObject.OrganizationName)}</td></tr>
                {renderContactTableRows(dataObject)}
                <tr><td colSpan={2}><strong>Geographical Address</strong></td></tr>
                <tr><td style={{ paddingLeft: "24px" }}>Address Complement</td><td>{safeVal(address.AddressComplement)}</td></tr>
                <tr><td style={{ paddingLeft: "24px" }}>Street</td><td>{safeVal(address.Street)}</td></tr>
                <tr><td style={{ paddingLeft: "24px" }}>Street Number</td><td>{safeVal(address.StreetNum)}</td></tr>
                <tr><td style={{ paddingLeft: "24px" }}>PO Box</td><td>{safeVal(address.POBox)}</td></tr>
                <tr><td style={{ paddingLeft: "24px" }}>Post Code</td><td>{safeVal(address.PostCode)}</td></tr>
                <tr><td style={{ paddingLeft: "24px" }}>City</td><td>{safeVal(address.City)}</td></tr>
                <tr><td style={{ paddingLeft: "24px" }}>Country</td><td>{safeVal(address.Country?.Text || address.Country?.Value)}</td></tr>
                <tr><td style={{ paddingLeft: "24px" }}>GPS Latitude</td><td>{safeVal(address.GPSCoordinates?.Latitude?.Value)}</td></tr>
                <tr><td style={{ paddingLeft: "24px" }}>GPS Longitude</td><td>{safeVal(address.GPSCoordinates?.Longitude?.Value)}</td></tr>
            </>
        );
    };

    const hiddenPayload = toStoredDesigner(isEditing ? formData : viewData);
    const needsSrnOptionalFields = !(formData.SRN && String(formData.SRN).trim());

    return (
        <div className="view-task-field">
            <div className="view-task-field-line">
                <div className="view-task-field-title">{fieldTitle}</div>
                <div className="view-task-field-value">
                    <div style={{ backgroundColor: '#f8f8f8', padding: '10px' }}>
                        {isEditing ? (
                            <div>
                                SRN: <br />
                                <input type="text" name="SRN" value={safeVal(formData.SRN)} onChange={handleInputChange} />
                                <br /><br />

                                Language: <br />
                                <select value={formData.Language?.Value || ''} onChange={handleLanguageChange} style={{ width: '90%' }}>
                                    <option value="">-- Select Language --</option>
                                    {languages.map(lang => (
                                        <option key={lang.key} value={lang.key}>{lang.value}</option>
                                    ))}
                                </select>
                                <br /><br />

                                Organization Name{needsSrnOptionalFields ? " *" : ""}: <br />
                                <input
                                    type="text"
                                    name="OrganizationName"
                                    className={fieldErrors.OrganizationName ? "form-field-error" : ""}
                                    value={safeVal(formData.OrganizationName)}
                                    onChange={handleInputChange}
                                />
                                {renderFieldError(fieldErrors.OrganizationName)}
                                <br /><br />

                                <strong>Contact Details</strong>
                                {renderFieldError(fieldErrors.ContactDetails)}
                                <br /><br />
                                {contactForm.ContactDetail.map((contact, index) => (
                                    <div key={`contact-edit-${index}`} style={{ marginBottom: "16px", paddingBottom: "12px", borderBottom: "1px solid #ddd" }}>
                                        {contactForm.ContactDetail.length > 1 ? <strong>Contact {index + 1}</strong> : null}
                                        <br />
                                        Email{needsSrnOptionalFields ? " *" : ""}: <br />
                                        <input
                                            type="text"
                                            name="EMail"
                                            className={fieldErrors[`Contact_${index}_EMail`] ? "form-field-error" : ""}
                                            value={safeVal(contact.EMail)}
                                            onChange={(e) => handleContactChange(index, "EMail", e.target.value)}
                                        />
                                        {renderFieldError(fieldErrors[`Contact_${index}_EMail`])}
                                        <br /><br />
                                        Phone: <br />
                                        <input
                                            type="text"
                                            name="Phone"
                                            value={safeVal(contact.Phone)}
                                            onChange={(e) => handleContactChange(index, "Phone", e.target.value)}
                                        />
                                        <br /><br />
                                        Public{needsSrnOptionalFields ? " *" : ""}: <br />
                                        <select
                                            className={fieldErrors[`Contact_${index}_Public`] ? "form-field-error" : ""}
                                            value={contact.Public === true ? "true" : contact.Public === false ? "false" : ""}
                                            onChange={(e) => handleContactChange(index, "Public", e.target.value === "" ? "" : e.target.value === "true")}
                                        >
                                            <option value="">-- Select --</option>
                                            <option value="true">Yes</option>
                                            <option value="false">No</option>
                                        </select>
                                        {renderFieldError(fieldErrors[`Contact_${index}_Public`])}
                                        <br /><br />
                                        Website: <br />
                                        <input
                                            type="text"
                                            name="Website"
                                            value={safeVal(contact.Website)}
                                            onChange={(e) => handleContactChange(index, "Website", e.target.value)}
                                        />
                                        <br /><br />
                                        {contactForm.ContactDetail.length > 1 ? (
                                            <>
                                                <input type="button" className="udiActionButton" value="Remove Contact" onClick={() => removeContactRow(index)} />
                                                <br /><br />
                                            </>
                                        ) : null}
                                    </div>
                                ))}
                                <input type="button" className="udiActionButton" value="Add Contact Detail" onClick={addContactRow} />
                                <br /><br />

                                <strong>Geographical Address</strong>
                                <br /><br />

                                Address Complement: <br />
                                <input type="text" name="AddressComplement" value={safeVal(addressForm.AddressComplement)} onChange={handleAddressChange} />
                                <br /><br />

                                Street: <br />
                                <input type="text" name="Street" value={safeVal(addressForm.Street)} onChange={handleAddressChange} />
                                <br /><br />

                                Street Number: <br />
                                <input type="text" name="StreetNum" value={safeVal(addressForm.StreetNum)} onChange={handleAddressChange} />
                                <br /><br />

                                PO Box: <br />
                                <input type="text" name="POBox" value={safeVal(addressForm.POBox)} onChange={handleAddressChange} />
                                <br /><br />

                                Post Code{needsSrnOptionalFields ? " *" : ""}: <br />
                                <input
                                    type="text"
                                    name="PostCode"
                                    className={fieldErrors.PostCode ? "form-field-error" : ""}
                                    value={safeVal(addressForm.PostCode)}
                                    onChange={handleAddressChange}
                                />
                                {renderFieldError(fieldErrors.PostCode)}
                                <br /><br />

                                City{needsSrnOptionalFields ? " *" : ""}: <br />
                                <input
                                    type="text"
                                    name="City"
                                    className={fieldErrors.City ? "form-field-error" : ""}
                                    value={safeVal(addressForm.City)}
                                    onChange={handleAddressChange}
                                />
                                {renderFieldError(fieldErrors.City)}
                                <br /><br />

                                Country{needsSrnOptionalFields ? " *" : ""}: <br />
                                <select
                                    name="Country"
                                    className={fieldErrors.Country ? "form-field-error" : ""}
                                    value={addressForm.Country?.Value || ''}
                                    onChange={handleAddressCountryChange}
                                    style={{ width: '90%' }}
                                >
                                    <option value="">-- Select Country --</option>
                                    {ADDRESS_COUNTRIES.map(c => (
                                        <option key={c.key} value={toCountryKey(c.key)}>{c.value}</option>
                                    ))}
                                </select>
                                {renderFieldError(fieldErrors.Country)}
                                <br /><br />

                                GPS Latitude: <br />
                                <input
                                    type="number"
                                    step="any"
                                    className={fieldErrors.GPS ? "form-field-error" : ""}
                                    value={safeVal(addressForm.GPSCoordinates?.Latitude?.Value)}
                                    onChange={(e) => handleGpsChange("Latitude", e.target.value)}
                                />
                                <br /><br />

                                GPS Longitude: <br />
                                <input
                                    type="number"
                                    step="any"
                                    className={fieldErrors.GPS ? "form-field-error" : ""}
                                    value={safeVal(addressForm.GPSCoordinates?.Longitude?.Value)}
                                    onChange={(e) => handleGpsChange("Longitude", e.target.value)}
                                />
                                {renderFieldError(fieldErrors.GPS)}

                                <input type="hidden" name={hiddenFieldName} value={JSON.stringify(hiddenPayload)} />
                            </div>
                        ) : (
                            <table className="dataTable" style={{ borderWidth: '1px', width: '100%' }}>
                                <thead>
                                    <tr><th>Field</th><th>Value</th></tr>
                                </thead>
                                <tbody>
                                    {renderTableRows(viewData)}
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProductDesignerLink;
